import { render, staticRenderFns } from "./DriverLayout.vue?vue&type=template&id=dfee4f5a&scoped=true"
import script from "./DriverLayout.vue?vue&type=script&lang=js"
export * from "./DriverLayout.vue?vue&type=script&lang=js"
import style0 from "./DriverLayout.vue?vue&type=style&index=0&id=dfee4f5a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfee4f5a",
  null
  
)

export default component.exports